import React from "react";
import { PropTypes } from "prop-types";

const FormInput3 = ({
  type,
  label,
  field,
  subLabel,
  form,
  onChange,
  onBlur,
  name,
  onFocus,
  placeholder,
}) => {
  return (
    <div>
      <div className="form3-input-container">
        <label className="form3-label">
          <span>{subLabel}</span>
          {label}
        </label>
        <input
          type={type}
          placeholder={placeholder}
          onFocus={onFocus}
          onChange={(field && field.onChange) || onChange}
          onBlur={(field && field.onBlur) || onBlur}
          value={(field && field.value) || ""}
          name={(field && field.name) || name}
          className="form3-input"
        />
      </div>
      {form && form.touched[field.name] && form && form.errors[field.name] && (
        <small className="errors2">{form.errors[field.name]}</small>
      )}
    </div>
  );
};

FormInput3.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  subLabel: PropTypes.string
}

export default FormInput3;
